export function initProductAttributesToggle() {
  const wrap = document.querySelector('.product-attributes.has-toggle');
  if (!wrap) return;

  const btn = wrap.querySelector('.product-attributes__toggle');
  const label = btn.querySelector('.product-attributes__toggle-label');

  const textExpand   = 'Rozwiń wszystkie';
  const textCollapse = 'Zwiń';

  btn.addEventListener('click', () => {
    const expanded = wrap.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', expanded);
    label.textContent = expanded ? textCollapse : textExpand;
  });
}
